import React, { useState } from "react";
import { PayableCardHeader } from "../payable-card-header";
import { useSelector } from "react-redux";
import {
  getBiller,
  getSelectedPayableType,
  getPayableSession,
} from "selectors";
import { ContactAndTocFooter } from "components/ezpay/common/contact-and-toc-footer";
import { AmountForm } from "../amount-form";
import { useTranslation } from "react-i18next";
import {
  FREEFORM_NAMESPACE,
  VALIDATE_NAMESPACE,
} from "constants/i18n-namespaces";
import { useLabelsWithKrn } from "hooks";
import {
  getLabelWithKrn,
} from "utilities/helper";
import { Navigate } from "react-router";
import routing from "routing";
import triangleWarning from "assets/icons/triangle_exclamation.svg";

export interface AmountContainerProps {
  setBannerState: any;
}

export const AmountContainer = (props: AmountContainerProps) => {
  const { setBannerState } = props;
  const { t } = useTranslation(VALIDATE_NAMESPACE);
  const biller = useSelector(getBiller);
  const [selectedBusinessUnitError, setSelectedBusinessUnitError] = useState(false);
  const { getLabelsWithKrn } = useLabelsWithKrn();
  const labelSourceWithKrn = useSelector(getLabelsWithKrn) as { labelsWithKrn: any };

  const payableTypeFromStore = useSelector(getSelectedPayableType);
  const payableSession = useSelector(getPayableSession);

  const selectedPayableType =
    payableSession?.payableType ?? payableTypeFromStore;

  if (!selectedPayableType) {
    return <Navigate to={routing.index()} />;
  }

  return (
    <div>
      <div className="ez-pay-payable-frame">
        <PayableCardHeader />
        {selectedBusinessUnitError && (
          <div className="validate-error">
            <img
              src={triangleWarning}
              alt={`${t("invalid-entry")}`}
              className="validate-error-icon"
            />
            <div>
              <div className="validation-error-header">
                {t("invalid-entry")}
              </div>
              <div className="validation-error-message">
                {t(
                  "business-unit-field-required",
                  {
                    ns: FREEFORM_NAMESPACE,
                    businessUnitType: getLabelWithKrn(
                      labelSourceWithKrn.labelsWithKrn,
                      selectedPayableType.typeKrn,
                      "businessUnitType"
                    )
                  }
                )}
              </div>
            </div>
          </div>
        )}

        {biller && (
          <AmountForm
            setBannerState={setBannerState}
            biller={biller}
            selectedPayableType={selectedPayableType}
            selectedBusinessUnitError={selectedBusinessUnitError}
            setSelectedBusinessUnitError={setSelectedBusinessUnitError}
          />
        )}
        <ContactAndTocFooter biller={biller} />
      </div>
    </div>
  );
};